import React from 'react'
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'

import './style.css'
import Formular230 from './views/formular230'
import Home from './views/home'
import Multumim from './views/multumim'
import NotFound from './views/not-found'
import Termeni from './views/termeni'
import GDPR from './views/gdpr'
import Confidentialitate from './views/confidentialitate'
import MainNavbar from './components/MainNavbar'

const App = () => {
  return (
    <Router>
      <MainNavbar />
      <Switch>
        <Route component={Home} exact path="/" />
        <Route component={Formular230} exact path="/formular230" />
        <Route component={Multumim} exact path="/multumim" />
        <Route component={Termeni} exact path="/termeni" />
        <Route component={GDPR} exact path="/gdpr" />
        <Route component={Confidentialitate} exact path="/confidentialitate" />
        <Route component={NotFound} path="**" />
        <Redirect to="**" />
      </Switch>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('root'))
